<div class="tw-flex tw-flex-col tw-gap-4">
  <!-- Medicamento no sustituido -->
  <p 
    class="tw-text-center tw-text-sm tw-bg-green-100 tw-text-green-800 tw-py-2 tw-px-3 tw-rounded-md"
    *ngIf="!replacementMedicine && !loadingReplacementMedicineData"
  >
    Este medicamento no tiene sustituto
  </p>

  <!-- Sustituto actual -->
  <div class="tw-flex tw-flex-col tw-gap-2" *ngIf="replacementMedicine">
    <span class="tw-pl-2 tw-text-xs tw-text-primary tw-font-bold tw-uppercase">Medicamento sustituido por</span>
    <div class="tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg tw-p-4 tw-flex tw-flex-col tw-gap-3">
      <!-- Nombre del medicamento -->
      <div class="tw-flex tw-items-start tw-justify-between">
        <h3 class="tw-text-base tw-font-semibold tw-text-gray-900">{{ replacementMedicine.med.nam }}</h3>
        <span 
          class="tw-px-2 tw-py-1 tw-text-xs tw-rounded-full" 
          [class]="replacementMedicine.med.nostk > 0 ? 'tw-bg-red-100 tw-text-red-800' : 'tw-bg-green-100 tw-text-green-800'">
          {{ replacementMedicine.med.nostk > 0 ? 'Sin stock' : 'Disponible' }}
        </span>
      </div>

      <!-- Información básica -->
      <div class="tw-bg-gray-50 tw-rounded-lg tw-p-4">
        <h4 class="tw-text-sm tw-font-semibold tw-text-gray-700 tw-mb-3 tw-flex tw-items-center">
          <svg class="tw-w-4 tw-h-4 tw-mr-2 tw-text-blue-500" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
          </svg>
          Información del medicamento
        </h4>
        <div class="tw-flex tw-gap-3">
          <div class="tw-h-fit tw-bg-white tw-rounded-md tw-pl-3 tw-p-1 tw-border tw-border-gray-200 tw-flex tw-items-center tw-justify-between">
            <span class="tw-text-xs tw-text-gray-500 tw-uppercase tw-tracking-wide tw-font-medium">Código</span>
            <span class="tw-text-sm tw-font-semibold tw-text-gray-900 tw-bg-blue-50 tw-px-2 tw-py-1 tw-rounded">{{ replacementMedicine.med.did }}</span>
          </div>
          <div class="tw-h-fit tw-bg-white tw-rounded-md tw-pl-3 tw-p-1 tw-border tw-border-gray-200 tw-flex tw-items-center tw-justify-between" *ngIf="replacementMedicine.med.CMS">
            <span class="tw-text-xs tw-text-gray-500 tw-uppercase tw-tracking-wide tw-font-medium">CMS</span>
            <span class="tw-text-sm tw-font-semibold tw-text-gray-900 tw-bg-green-50 tw-px-2 tw-py-1 tw-rounded">{{ replacementMedicine.med.CMS }}</span>
          </div>
          <div class="tw-h-fit tw-bg-white tw-rounded-md tw-pl-3 tw-p-1 tw-border tw-border-gray-200 tw-flex tw-items-center tw-justify-between" *ngIf="replacementMedicine.med.Presentacion">
            <span class="tw-text-xs tw-text-gray-500 tw-uppercase tw-tracking-wide tw-font-medium">Presentación</span>
            <span class="tw-text-sm tw-font-semibold tw-text-gray-900 tw-bg-gray-50 tw-px-2 tw-py-1 tw-rounded">{{ replacementMedicine.med.Presentacion }}</span>
          </div>
          <div class="tw-h-fit tw-bg-white tw-rounded-md tw-pl-3 tw-p-1 tw-border tw-border-gray-200 tw-flex tw-items-center tw-justify-between" *ngIf="replacementMedicine.med.price">
            <span class="tw-text-xs tw-text-gray-500 tw-uppercase tw-tracking-wide tw-font-medium">Precio</span>
            <span class="tw-text-sm tw-font-bold tw-text-green-700 tw-bg-green-50 tw-px-2 tw-py-1 tw-rounded">{{ replacementMedicine.med.price | currency:'EUR':'symbol':'1.2-2' }}</span>
          </div>
        </div>
      </div>

      <!-- Flags del medicamento -->
      <div class="tw-flex tw-flex-wrap tw-gap-1" *ngIf="replacementMedicine.med.paymed || replacementMedicine.med.nobl || replacementMedicine.med.obsol">
        <span class="tw-px-2 tw-py-1 tw-text-xs tw-bg-blue-100 tw-text-blue-800 tw-rounded-full" *ngIf="replacementMedicine.med.paymed">
          Medicamento de pago
        </span>
        <span class="tw-px-2 tw-py-1 tw-text-xs tw-bg-yellow-100 tw-text-yellow-800 tw-rounded-full" *ngIf="replacementMedicine.med.nobl">
          Sin blister
        </span>
        <span class="tw-px-2 tw-py-1 tw-text-xs tw-bg-red-100 tw-text-red-800 tw-rounded-full" *ngIf="replacementMedicine.med.obsol">
          Obsoleto
        </span>
      </div>

      <!-- Principios activos -->
      <div *ngIf="replacementMedicine.med.PA && replacementMedicine.med.PA.length > 0">
        <h4 class="tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-1">Principios activos:</h4>
        <div class="tw-flex tw-flex-wrap tw-gap-1">
          <span *ngFor="let pa of replacementMedicine.med.PA" 
                class="tw-px-2 tw-py-1 tw-text-xs tw-bg-gray-100 tw-text-gray-700 tw-rounded">
            {{ pa.Nombre }}
          </span>
        </div>
      </div>

      <!-- Boton confirmación -->
      <div class="tw-flex tw-justify-center">
        <button 
          mat-raised-button 
          color="primary" 
          [disabled]="cancelingReplacement" 
          (click)="cancelReplacement()"
        >
          <span *ngIf="!cancelingReplacement">Anular sustitución</span>
          <span *ngIf="cancelingReplacement" class="tw-flex tw-items-center tw-gap-2">
            <mat-spinner diameter="20"></mat-spinner>
            Sustituyendo...
          </span>
        </button>
        
      </div>
    </div>
  </div>

  <!-- Anadir sustituto -->
  <div class="tw-flex tw-flex-col tw-gap-2" *ngIf="!loadingReplacementMedicineData">
    <span class="tw-pl-2 tw-text-xs tw-text-primary tw-font-bold tw-uppercase">Sustituir por</span>
    <app-form-field
      #medicina
      type="autocomplete"
      label="Nombre medicamento"
      class="field [&_mat-form-field]:!tw-mb-0"
      [class]="form.controls['medicineInput'].value?.flags?.noStock ? 'col-10' : 'col-12'"
      [fieldControl]="form.controls['medicineInput'] | asFormControl"
      [options]="medicinesOptions"
      [customFieldData]="{compareStart: true}"
      [hideSingleSelectionIndicator]="true"
    ></app-form-field>
  </div>

  <!-- Nuevo sustituto -->
  <div class="tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg tw-p-4 tw-flex tw-flex-col tw-gap-3" *ngIf="medicine">
    <!-- Nombre del medicamento -->
    <div class="tw-flex tw-items-start tw-justify-between">
      <h3 class="tw-text-base tw-font-semibold tw-text-gray-900">{{ medicine.med.nam }}</h3>
      <span 
        class="tw-px-2 tw-py-1 tw-text-xs tw-rounded-full" 
        [class]="medicine.med.nostk > 0 ? 'tw-bg-red-100 tw-text-red-800' : 'tw-bg-green-100 tw-text-green-800'">
        {{ medicine.med.nostk > 0 ? 'Sin stock' : 'Disponible' }}
      </span>
    </div>

    <!-- Información básica -->
    <div class="tw-bg-gray-50 tw-rounded-lg tw-p-4">
      <h4 class="tw-text-sm tw-font-semibold tw-text-gray-700 tw-mb-3 tw-flex tw-items-center">
        <svg class="tw-w-4 tw-h-4 tw-mr-2 tw-text-blue-500" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
        </svg>
        Información del medicamento
      </h4>
      <div class="tw-flex tw-gap-3">
        <div class="tw-h-fit tw-bg-white tw-rounded-md tw-pl-3 tw-p-1 tw-border tw-border-gray-200 tw-flex tw-items-center tw-justify-between">
          <span class="tw-text-xs tw-text-gray-500 tw-uppercase tw-tracking-wide tw-font-medium">Código</span>
          <span class="tw-text-sm tw-font-semibold tw-text-gray-900 tw-bg-blue-50 tw-px-2 tw-py-1 tw-rounded">{{ medicine.med.did }}</span>
        </div>
        <div class="tw-h-fit tw-bg-white tw-rounded-md tw-pl-3 tw-p-1 tw-border tw-border-gray-200 tw-flex tw-items-center tw-justify-between" *ngIf="medicine.med.CMS">
          <span class="tw-text-xs tw-text-gray-500 tw-uppercase tw-tracking-wide tw-font-medium">CMS</span>
          <span class="tw-text-sm tw-font-semibold tw-text-gray-900 tw-bg-green-50 tw-px-2 tw-py-1 tw-rounded">{{ medicine.med.CMS }}</span>
        </div>
        <div class="tw-h-fit tw-bg-white tw-rounded-md tw-pl-3 tw-p-1 tw-border tw-border-gray-200 tw-flex tw-items-center tw-justify-between" *ngIf="medicine.med.Presentacion">
          <span class="tw-text-xs tw-text-gray-500 tw-uppercase tw-tracking-wide tw-font-medium">Presentación</span>
          <span class="tw-text-sm tw-font-semibold tw-text-gray-900 tw-bg-gray-50 tw-px-2 tw-py-1 tw-rounded">{{ medicine.med.Presentacion }}</span>
        </div>
        <div class="tw-h-fit tw-bg-white tw-rounded-md tw-pl-3 tw-p-1 tw-border tw-border-gray-200 tw-flex tw-items-center tw-justify-between" *ngIf="medicine.med.price">
          <span class="tw-text-xs tw-text-gray-500 tw-uppercase tw-tracking-wide tw-font-medium">Precio</span>
          <span class="tw-text-sm tw-font-bold tw-text-green-700 tw-bg-green-50 tw-px-2 tw-py-1 tw-rounded">{{ medicine.med.price | currency:'EUR':'symbol':'1.2-2' }}</span>
        </div>
      </div>
    </div>

    <!-- Flags del medicamento -->
    <div class="tw-flex tw-flex-wrap tw-gap-1" *ngIf="medicine.med.paymed || medicine.med.nobl || medicine.med.obsol">
      <span class="tw-px-2 tw-py-1 tw-text-xs tw-bg-blue-100 tw-text-blue-800 tw-rounded-full" *ngIf="medicine.med.paymed">
        Medicamento de pago
      </span>
      <span class="tw-px-2 tw-py-1 tw-text-xs tw-bg-yellow-100 tw-text-yellow-800 tw-rounded-full" *ngIf="medicine.med.nobl">
        Sin blister
      </span>
      <span class="tw-px-2 tw-py-1 tw-text-xs tw-bg-red-100 tw-text-red-800 tw-rounded-full" *ngIf="medicine.med.obsol">
        Obsoleto
      </span>
    </div>

    <!-- Principios activos -->
    <div *ngIf="medicine.med.PA && medicine.med.PA.length > 0">
      <h4 class="tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-1">Principios activos:</h4>
      <div class="tw-flex tw-flex-wrap tw-gap-1">
        <span *ngFor="let pa of medicine.med.PA" 
              class="tw-px-2 tw-py-1 tw-text-xs tw-bg-gray-100 tw-text-gray-700 tw-rounded">
          {{ pa.Nombre }}
        </span>
      </div>
    </div>

    <!-- Información adicional -->
    <p class="tw-text-center tw-text-sm tw-bg-orange-100 tw-text-orange-800 tw-py-2 tw-px-3 tw-rounded-md">Ten en cuenta que al sustituir un medicamento, se sustituirán todas las prescripciones que tengan este medicamento.</p>

    <!-- Boton confirmación -->
    <div class="tw-flex tw-justify-center">
      <button 
        mat-raised-button 
        color="primary" 
        [disabled]="replacingMedicine" 
        (click)="replaceMedicine()"
      >
        <span *ngIf="!replacingMedicine">Sustituir por este medicamento</span>
        <span *ngIf="replacingMedicine" class="tw-flex tw-items-center tw-gap-2">
          <mat-spinner diameter="20"></mat-spinner>
          Sustituyendo...
        </span>
      </button>
      
    </div>
  </div>

  <!-- Loading medicine data -->
  <div class="tw-flex tw-justify-center tw-items-center tw-h-full gap-2" *ngIf="loadingMedicineData">
    <mat-spinner [diameter]="20"></mat-spinner>
    <span class="tw-text-sm tw-text-primary">Cargando datos del medicamento...</span>
  </div>

  <!-- Loading replacement medicine data -->
  <div class="tw-flex tw-justify-center tw-items-center tw-h-full gap-2" *ngIf="loadingReplacementMedicineData">
    <mat-spinner [diameter]="20"></mat-spinner>
    <span class="tw-text-sm tw-text-primary">Cargando datos del medicamento sustituto...</span>
  </div>
</div>